
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCClearanceDialog extends _Ext.DialogBase<PDCClearanceRow, any> {
        protected getFormKey() { return PDCClearanceForm.formKey; }
        protected getIdProperty() { return PDCClearanceRow.idProperty; }
        protected getLocalTextPrefix() { return PDCClearanceRow.localTextPrefix; }
        protected getNameProperty() { return PDCClearanceRow.nameProperty; }
        protected getService() { return PDCClearanceService.baseUrl; }
        protected getDeletePermission() { return PDCClearanceRow.deletePermission; }
        protected getInsertPermission() { return PDCClearanceRow.insertPermission; }
        protected getUpdatePermission() { return PDCClearanceRow.updatePermission; }
        protected form = new PDCClearanceForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();
            //q.setTextRightAlign(this.form.Amount);
            //q.setTextRightAlign(this.form.ChequeNo);
            q.hideEditorLabel(this.form.Details);
            q.hideEditorToolbar(this.form.Details);
            var vouchers;

            this.form.PDCTypeId.changeSelect2(e => {
                var type = this.form.PDCTypeId.value;


                Q.confirm('All Vouchers Loaded will be removed,Do you wish to continue? ', () => {
                    if (type == "1") {
                        PDCReceivableService.VoucherList({
                        },
                            response => vouchers = response, {
                            async: false
                        });
                        let newvouchers = [];
                        for (var i = 0; i < vouchers.Entities.length; i++) {
                            var oldvoucher = vouchers.Entities[i];
                            var newvoucher: PDCClearanceDetailsRow = {
                                AgainstId: oldvoucher.BankId,
                                Amount: oldvoucher.Amount,
                                ChequeDate: oldvoucher.ChequeDate,
                                ChequeNo: oldvoucher.ChequeNo,
                                CreatedBy: oldvoucher.CreatedBy,
                                LedgerId: oldvoucher.PartyId,
                                LedgerName: oldvoucher.LedgerName,
                                VoucherNo: oldvoucher.VoucherNo,
                                VoucherTypeId: oldvoucher.VoucherTypeId,
                                Status: oldvoucher.Status,
                                CompanyId: oldvoucher.CompanyId,
                                FinancialYearId: oldvoucher.FinancialYearId,
                                RefTransId: oldvoucher.TransId
                            }
                            newvouchers.push(newvoucher);
                        }
                        var newdata = this.form.Details.setitems(newvouchers);
                        this.form.Details.view.setItems(newdata, true);
                    } else {
                        PDCPayableService.VoucherList({
                        },
                            response => vouchers = response, {
                            async: false
                        });
                        let newvouchers = [];
                        for (var i = 0; i < vouchers.Entities.length; i++) {
                            var oldvoucher = vouchers.Entities[i];
                            var newvoucher: PDCClearanceDetailsRow = {
                                AgainstId: oldvoucher.BankId,
                                Amount: oldvoucher.Amount,
                                CreatedBy: oldvoucher.CreatedBy,
                                ChequeDate: oldvoucher.ChequeDate,
                                ChequeNo: oldvoucher.ChequeNo,
                                LedgerId: oldvoucher.PartyId,
                                LedgerName: oldvoucher.LedgerName,
                                VoucherNo: oldvoucher.VoucherNo,
                                VoucherTypeId: oldvoucher.VoucherTypeId,
                                Status: oldvoucher.Status,
                                CompanyId: oldvoucher.CompanyId,
                                FinancialYearId: oldvoucher.FinancialYearId,
                                RefTransId: oldvoucher.TransId
                            }
                            newvouchers.push(newvoucher);

                        }
                        var newdata = this.form.Details.setitems(newvouchers);
                        this.form.Details.view.setItems(newdata, true);
                    }
                });





            })
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (!this.isNew()) {
                this.form.PDCTypeId.set_readOnly(true);
                this.toolbar.findButton('save-and-close-button').hide();
                this.toolbar.findButton('apply-changes-button').hide();
            }
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            if (!this.isNew()) {
                buttons = buttons.slice(1);
            }
            return buttons;
        }

    }

}